import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contect',
  templateUrl: './contect.component.html',
  styleUrls: ['./contect.component.css']
})
export class ContectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
